import React from 'react';
import ChildItemLevelReport from './ChildItemLevelReport'
import ParentItemLevelReport from './ParentItemLevelReport'
import { get } from '../../../util/helperFunctions'

const ItemLevelReport = ({ reportDetails }) => {
  // This is setting up all the questions and answers so we can quickly pass the following
  // variables into the DetailsQuestionTable component for display
  const crafft = [];
  const sbirt = [];
  const cat = [];
  const cmrs = [];
  const gad = [];
  const cmrsParent = [];
  const gadParent = [];

  const childArray = get(['questions', 'child'], reportDetails, [])
  childArray.forEach((q) => {
    // if (q.question_name === 'phq_9' && q.question.startsWith('phq_9: 9')) phqNineNineScore = q.answer_text
    if (q.question_name.startsWith('crafft')) crafft.push(q)
    if (q.question_name.startsWith('sbirt')) sbirt.push(q)
    if (q.question_name.startsWith('child_cat_')) cat.push(q)
    if (q.question_name.startsWith('cmrs')) cmrs.push(q)
    if (q.question_name.startsWith('gad7')) gad.push(q)
  })

  const parentArray = get(['questions', 'guardian'], reportDetails, [])
  parentArray.forEach((q) => {
    if (q.question_name.startsWith('cmrs')) cmrsParent.push(q)
    if (q.question_name.startsWith('gad')) gadParent.push(q)
  })

  return (
    <>
      <ChildItemLevelReport
        reportDetails={reportDetails}
        crafftDetails={crafft}
        sbirtDetails={sbirt}
        catDetails={cat}
        cmrsDetails={cmrs}
        gadDetails={gad}
      />
      <ParentItemLevelReport
        reportDetails={reportDetails}
        cmrsDetails={cmrsParent}
        gadDetails={gadParent}
      />
    </>
  )
}

export default ItemLevelReport
